module.exports = __webpack_public_path__ + "img/22.b242af88.jpg";